import React from 'react'
import { SVGIconProps } from '../types'
const SvgHorizontalRule = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path fillRule="evenodd" d="M4 11h16v2H4z" />
  </svg>
)
export default SvgHorizontalRule
